module.exports = __webpack_public_path__ + "img/pingaksh_logo_white_new.3d40f347.png";